import AppConfig from "../control/config";
import IMApp from "./IMApp";
import AppUtils from "../control/apputlis";
import IMSocketMgr from "./IMSocketMgr";

export default class IMApis {


    static random(from, to) {
        if (from == to) return from;
        let rd = Math.round(Math.random() * 10);
        return from + (rd % (to - from));
    }

    static request(method, param, callback, url) {
        let formData = new FormData();
        var uid = IMApp.user.uid;
        // console.log('IMApp.hostApi',IMApp.hostApi);

        let d = JSON.stringify({
            method: method,
            param: param,
            siteid: IMApp.channelid,
            
            version: IMApp.version, 
            deviceid: IMApp.deviceid,
            uid,
            channel: AppConfig.freeLanchannelid,
            ip: '',
        })
        formData.append(
            'win_param',
            d,
        );

        if (!url) {
            //'https://frljk.imtgb.cn/api/flashapi.php';
            url = IMApp.hostApi;
            if (!url) {
                url = "https://frljk.im1q.cn/";
            }
        }

        url = url + "api/flashapi.php";

        fetch(url, {
            method: 'POST',
            body: formData,
        }).then(res => {
            return res.text();
        }).then(json => {
            try {
                let data = JSON.parse(json);
                callback && callback(null, data);
            } catch (e) {
                callback(e, null);
            }
        }).catch(e => {
            callback && callback(e, null);
        });
    }

    static post(method, param) {
        return new Promise((resolve, reject) => {
            IMApis.request(method, param, (e, result) => {
                if (result) {
                    resolve(result)
                } else {
                    reject(e)
                }
            });
        })
    }


    //验证码登录
    static login(zone, phone, verifycode) {
        let param = { zone: zone, uno: phone, verifycode: verifycode };
        return IMApis.post('IMUser.verifyLogin', param);
    }
    //快捷登录登录
    static fastLogin2(phone, fastkey) {
        let param = { uno: phone, fastkey: fastkey };
        return IMApis.post('IMUser.fastLogin', param);
    }

    //游客登录
    static ykLogin() {
        let param = { channel: AppConfig.freeLanchannelid, deviceid: AppConfig.deviceid };
        return IMApis.post('IMUser.guestLogin', param);
    }

    //密码登录
    static passWordlogin(phone, password) {
        password = AppUtils.md5(password);
        let param = { uno: phone, loginpasswd: password };
        return IMApis.post('IMUser.passwdLogin', param);
    }

    //忘记密码
    static FindPassword(phone, code, password) {
        password = AppUtils.md5(password);
        let param = { uno: phone, verifycode: code, newpasswd: password };
        return IMApis.post('IMTools.forgetLoginPassWD', param);
    }
    //设置密码
    static SetPassword(password) {
        password = AppUtils.md5(password);
        let param = { loginpasswd: password };
        return IMApis.post('IMTools.setLoginPassWD', param);
    }
    //修改密码
    static changePassword(oldPassword, password) {
        password = AppUtils.md5(password);
        oldPassword = AppUtils.md5(oldPassword);
        let param = { newpasswd: password, oldpasswd: oldPassword };
        return IMApis.post('IMTools.modifyLoginPassWD', param);
    }

    //检查是否有登录密码密码
    static checkPassword() {
        let param = {};
        return IMApis.post('IMTools.getLoginPasswdState', param);
    }

    static getCode(zone, phone) {
        let param = { zone: zone, uno: phone, mtype: 0 };
        return IMApis.post('IMTools.getValid', param);
    }

    static connectWebSocket(result) {
        IMApp.loadData(result);
        let server = IMApp.getServer();
        IMSocketMgr.connectServer(server.svrip, server.websvrport);
    }

    static fastLogin(phone, fastkey) {
        let param = { uno: phone, fastkey: fastkey };
        return IMApis.post('IMUser.fastLogin', param);
    }

    static imThirdLogin(phone, uid) {
        let param = { uno: phone, usertype: 0, thirduid: uid };
        return IMApis.post('IMUser.thirdLogin', param);
    }

    // static thirdLogin(phone, uid, fastkey) {
    //     return new Promise((resolve, reject) => {
    //         if (fastkey && fastkey.length != 0) { 
    //             IMApis.fastLogin(phone, fastkey).then(result => {
    //                 console.log('thirdLogin=========>', result);
    //                 if (result.ret == 0) {
    //                     IMApp.loadData(result);
    //                     let server = IMApp.getServer();
    //                     IMSocketMgr.connectServer(server.svrip, server.websvrport);
    //                     resolve(result);
    //                 } else {
    //                     reject(result);
    //                 }
    //             }).catch(e => {
    //                 reject(e);
    //             })
    //         } else {
    //             IMApis.imThirdLogin(phone, uid).then(result => {
    //                 console.log('thirdLogin=========>', result);
    //                 if (result.ret == 0) {
    //                     IMApp.loadData(result);
    //                     let server = IMApp.getServer();
    //                     IMSocketMgr.connectServer(server.svrip, server.websvrport);
    //                     resolve(result);
    //                 } else {
    //                     reject(result);
    //                 }
    //             }).catch(e => {
    //                 reject(e);
    //             })
    //         }
    //     })


    // }

    //修改登录
    static thirdLogin(result) {
        return new Promise((resolve, reject) => {
            IMApp.loadData(result);
            let server = IMApp.getServer();
            IMSocketMgr.connectServer(server.svrip, server.websvrport);
            resolve(result);
        })


    }

    static getPayPasswdState() {
        return IMApis.post('IMTools.getPayPasswdState', { uid: IMApp.user.uid });
    }



    static imLogin(phone, fastkey) {
        return new Promise((resolve, reject) => {
            IMApis.fastLogin(phone, fastkey).then(result => {
                console.log('imLogin=========>', result);
                if (result.ret == 0) {
                    IMApp.loadData(result);
                    let server = IMApp.getServer();
                    IMSocketMgr.connectServer(server.svrip, server.websvrport);
                    resolve(result);
                } else {
                    reject(result);
                }
            }).catch(e => {
                reject(e);
            })
        })
    }

    static uploadFile(file, callback) {
        let formData = new FormData();
        formData.append('pic', file);
        fetch(IMApp.imUploadApi, {
            method: 'POST',
            body: formData,
        }).then(res => {
            return res.text();
        }).then(json => {
            try {
                let data = JSON.parse(json);
                callback && callback(null, data);
            } catch (e) {
                callback(e, null);
            }
        }).catch(e => {
            callback && callback(e, null);
        });
    }

}
